import React from "react";
import { Row } from "react-bootstrap";
import { SliderPage } from ".";
import { useProduct } from "../adapters/uplist";
import {
  MATTERPORT_SAMPLES,
  MATTERTAG_SAMPLES,
} from "../assets/images/samples";
import { InternalSection } from "../components";
import { BlockCheckbox, InlineCheckbox, Input } from "../components/fields";
import { Notes } from "../components/fields/Notes";
import AddOnSection from "../components/order/AddOnSection";
import { useProductWatcher } from "../context/ProductWatcherContext";
import { MATTERPORT_APPT_SKUS } from "../helpers/constants";
import { useBuyXGetOneFree } from "../hooks";

const MatterportPage = () => {
  const { matterport_sku: sku } = useProductWatcher();
  const { data: matter_tag } = useProduct("5105");
  useBuyXGetOneFree({
    watch_sku: "matter_tag",
    free_sku: "5109",
    paid_sku: "5105",
    buy_x_count: 4,
  });
  return (
    <SliderPage title="Matterport">
      {sku && (
        <Row>
          <BlockCheckbox
            label="Matterport Virtual Open House"
            key={sku}
            sku={sku}
            modal={{ urls: MATTERPORT_SAMPLES, matterport: true }}
          />
        </Row>
      )}
      <AddOnSection
        title="Matterport Add-Ons"
        show_skus={MATTERPORT_APPT_SKUS}
        addon_skus={["matter_tag", "5104"]}
      >
        <Input
          type="number"
          sku="matter_tag"
          label={matter_tag.name}
          modal={{ urls: MATTERTAG_SAMPLES, matterport: true }}
          additional_price={matter_tag.price}
          description={matter_tag.description}
        />
        <AddOnSection
          show_skus={["matter_tag"]}
          addon_skus={["notes.virtual_open_house"]}
        >
          <Notes
            required
            name="matter_tag_notes"
            label="Matter Tag Notes"
            placeholder="Let us know what you would like tagged as well as any special instructions."
          />
        </AddOnSection>
        <InlineCheckbox sku="5104" />
      </AddOnSection>
      <InternalSection>
        <InlineCheckbox sku="5106" />
        <InlineCheckbox sku="5107" />
        <InlineCheckbox sku="5007" />
        <Notes name="notes.virtual_open_house" label="Matterport Notes" />
      </InternalSection>
    </SliderPage>
  );
};

export default MatterportPage;
